import {Deferred} from "simply-deferred";
import EventsCollectionDepricated from "src/core/model2/event/collection-depricated";
import Event from "../../model2/event/event"

const debug = {
    dev: false,
    head: 'EventSessionCollection'
}

export default class EventSessionCollection {

    constructor(models = []) {
        this._companyEvents = new EventsCollectionDepricated();
        this._personalEvents = new EventsCollectionDepricated();

        this._startMoment = Moment().subtract(30,'days');
    }

    get companyEvents() {
        return this._companyEvents.models;
    }

    get personalEvents() {
        return this._personalEvents.models;
    }

    // Load older events we might not have in sesison yet, used when we need to calculate old tasks workdays
    // or calendar events in the past....
    // Enter real date - we subtract 45 days automatically
    async loadOlderEvents(startMoment) {
        if (!startMoment.isBefore(this._startMoment)) {
            debug.dev && console.log(debug.head,".loadOlderEvents - no load needed")
            return true;
        } else {
            debug.dev && console.log(debug.head,".loadOlderEvents - loading older events")

            const deferredLoader = new Deferred(); // create new deferred object

            // mi "rasshiryam granicu chto bi zahvatti' drugie events ishodya iz togo chto max u nas na personal event 45 days
            const requestStartMoment = Moment(startMoment).subtract(45,'days');
            const requestEndMoment = Moment(this._startMoment);

            const request = gd.api.Session.loadOlderCompanyAndPersonalEvents(gd.companyId, requestStartMoment, requestEndMoment);
            request.done(response=>{
                // set new start Moment for the collection
                this._startMoment = Moment(startMoment);
                deferredLoader.resolve();
            })

            return deferredLoader;

        }
    }

    addOne(eventRaw) {
        this._add(eventRaw);
        gd.bus.triggerEvent('gd.session.events:change');
    }

    addMany(eventsRaw) {
        _.map(eventsRaw, eventRaw=>this._add(eventRaw));
        gd.bus.triggerEvent('gd.session.events:change');
    }

    reset(eventsRaw) {

        this._companyEvents = new EventsCollectionDepricated();
        this._personalEvents = new EventsCollectionDepricated();

        _.forEach(eventsRaw, eventRaw=>{
            this._add(eventRaw);
        })
    }

    get(eventId) {
        let event = this._personalEvents.get(eventId)
        if (!event) event = this._companyEvents.get(eventId)

        return event
    }

    _add(eventRaw) {
        const startDate = (eventRaw.startDate)?Moment(eventRaw.startDate):null;
        const endDate = (eventRaw.endDate)?Moment(eventRaw.endDate):null;

        // patch
        const eventType = eventRaw.type || eventRaw.eventType

        const eventModel = new Event({
            id              : eventRaw.id,
            eventType       : eventType,
            name            : eventRaw.name,
            startDate       : startDate,
            endDate         : endDate,
            assignedToUserId: eventRaw.assignedToUserId,
            createdByUserId : eventRaw.createdByUserId,
            userId          : eventRaw.userId,
            projectId       : eventRaw.projectId,
        })

        if (gd.const.event.companyTypes.includes(eventType)) {
            // company event
            this._companyEvents.add(eventModel);
        } else {
            // personal
            this._personalEvents.add(eventModel);
        }
    }

    remove(id) {
        this._personalEvents.remove(id);
        this._companyEvents.remove(id);

        gd.bus.triggerEvent('gd.session.events:change');
    }

    update(eventRaw) {

        if (!this._personalEvents.get(eventRaw.id) && !this._companyEvents.get(eventRaw.id)) {
            // no event found -> not update needed
            return;
        }

        this.remove(eventRaw.id);
        this._add(eventRaw);
        gd.bus.triggerEvent('gd.session.events:change');
    }

    applyDelta(eventId, data) {
        const event = this.get(eventId)
        if (event) event.applyDelta(data)
    }

    debug() {
        console.log("gd.sesion.events:");
        console.log("    company  : ", this._companyEvents.length);
        console.log("    personal : ", this._personalEvents.length);
    }

}